import React, { useEffect, useMemo, useState } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Button, Card, Col, Container, Row } from "reactstrap"
import Logo from "../../../assets/images/logo.svg"
import phoneImg from "../../../assets/images/phone.svg"
import webImg from "../../../assets/images/web.svg"
import locationImg from "../../../assets/images/location.svg"
import {
  downloadmr,
  fetchMRRequest,
} from "../../../services/procurement/materialrequest"
import moment from "moment"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import NumberFormat from "../../../utils/numberFormat"

const ViewSmr = ({ fromDashboard, viewValue }) => {
  const { id } = useParams()
  const viewId = fromDashboard ? viewValue?.value?.id : id
  const [requestDetails, setRequestDetails] = useState()
  const [tabledata, setTabledata] = useState()

  const companyname = localStorage.getItem("companyname")
  document.title = `Outward SMR${
    companyname ? ` | ${companyname}` : "MEP -Hub"
  }`

  const locations = useLocation();
  // const crumb = locations?.state?.menuLabel || ""
  const smr = locations?.state?.name || ""

  useEffect(() => {
    const fetchPOdata = async () => {
      const response = await fetchMRRequest(viewId)
      setRequestDetails(response?.data)
      setTabledata(response?.data?.materials)
    }
    if (viewId !== undefined) fetchPOdata()
  }, [])

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)
  const imgUrl = process.env.REACT_APP_IMG_APIKEY

  console.log(requestDetails, "requestDetails")
  return (
    <React.Fragment>
      <div
        className={`${
          fromDashboard ? "pt-0 dashboard-page-content-view" : "page-content"
        }`}
      >
        <div className="container-fluid">
          <div className="d-flex justify-content-between me-2">
            {!fromDashboard && (
              <Breadcrumbs
                title="Inventory"
                breadcrumbObject={[
                  { title: "Inventory", link: "/inventory" },
                  { title: smr == "Masters" ? "Masters" : smr == "Store Masters" ? "Store Masters" : "Inventory", link: smr == "Masters" ? "/procurement" : "/inventory" },
                  {
                    title: smr == "Masters" ? "SMR" : "Outward SMR",
                    link: smr == "Masters" ? "/procurement-smr" : "/inventory-outward-smr",
                  },
                  {
                    title: smr ? "View SMR" : "View Outward SMR",
                    link: "",
                  },
                ]}
              />
            )}
          </div>
          <Container fluid className="ps-lg-0">
            <Card className="supplier-card">
              <div className={`purchase-view-div ${fromDashboard && "wdt-96"}`}>
                <Row>
                  <Col>
                    <div className="d-flex justify-content-between me-2">
                      <h3 className="main-heading edittheamtitle">
                        Material Request{" "}
                      </h3>
                      <img className="view-logo" src={loggedUser?.settings?.companylogo ? `${imgUrl}${loggedUser?.settings?.companylogo}` : Logo} alt="logo" />
                    </div>

                    <Row className=" pb-2 mt-3">
                      <Col lg="3">
                        <span>SMR No</span>
                        <br />
                        <span className="fw-bold-700">
                          {requestDetails?.code}
                        </span>
                      </Col>
                      <Col lg="3">
                        <span>SMR Date</span>
                        <br />
                        <span className="fw-bold-700">
                          {moment(requestDetails?.created_at).format(
                            "DD-MM-YYYY"
                          )}
                        </span>
                      </Col>
                      <Col lg="3">
                        <span>PMR Reference</span>
                        <br />
                        <span className="fw-bold-700">
                          {requestDetails?.parent?.code ? requestDetails?.parent?.code : "-"}
                        </span>
                      </Col>
                      <Col lg="3">
                        <span>Exp Delivery Date</span>
                        <br />
                        <span className="fw-bold-700">
                          {moment(requestDetails?.exp_Delivery_date).format(
                            "DD-MM-YYYY"
                          )}
                        </span>
                      </Col>
                      {/* <Col lg="3">
                        <span>Requested by </span>
                        <br />
                        <span className="fw-bold-700">
                          {requestDetails?.requested_by
                            ? capitalize(requestDetails?.requested_by)
                            : "-"}
                        </span>
                      </Col> */}
                    </Row>
                    {/* <Row className=" pb-2 mt-3">
                      <Col lg="3">
                        <span>Delivery Location</span>
                        <br />
                        <span className="fw-bold-700">
                          {requestDetails?.delivery_location}
                        </span>
                      </Col>
                      <Col lg="6">
                        <span>Contact no</span>
                        <br />
                        <span className="fw-bold-700">
                          {requestDetails?.contact_number}
                        </span>
                      </Col>
                    </Row> */}
                    <Row className="mt-4">
                      <Col lg={12}>
                        <h5 className="productDetail edittheamtitle">
                          Material Details
                        </h5>
                      </Col>
                      <Col lg={12} className="table_height">
                        <table className="estimation-table mb-4">
                          <thead>
                            <tr>
                              <th>S No</th>
                              <th>Product Code</th>
                              {/* <th>Product Name</th> */}
                              <th>Description</th>
                              <th className="text-end pe-5">Ordered Qty</th>
                            </tr>
                          </thead>
                          <tbody>
                            {tabledata?.map((data, index) => {
                              return (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{data?.product?.product_code}</td>
                                  <td>{data?.product?.description}</td>
                                  {/* <td>{data.description} </td> */}
                                  <td className="text-end pe-5">
                                    {NumberFormat(
                                      Number(data.requested_quantity)
                                    )}
                                  </td>
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </Col>
                    </Row>
                    <div className="contact-us text-blue border-top mt-5 py-3 font-size-12">
                      <div className="d-flex justify-content-between align-items-center">
                      <h5 className="font-bold-800">Contact Us</h5>

                        <div className="contact-item d-flex align-items-center">
                          <img
                            src={phoneImg}
                            alt="phone"
                            className="footer-logo me-2"
                          />
                          +{loggedUser?.settings?.phone}
                        </div>
                        <div className="contact-item d-flex align-items-center">
                          <img
                            src={webImg}
                            alt="website"
                            className="footer-logo me-2"
                          />
                          {loggedUser?.settings?.website}
                        </div>
                        <div className="contact-item d-flex align-items-center">
                          <img
                            src={locationImg}
                            alt="location"
                            className="footer-logo me-2"
                          />
                          {loggedUser?.settings?.companyaddress}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
              {!fromDashboard && (
                <Row>
                  <Col lg={12}>
                    <div className="d-flex justify-content-between me-3">
                      <span></span>
                      <Button
                        form={`supplier-form`}
                        color={"primary"}
                        className={"px-2 mb-3 btn btn-primary"}
                        onClick={() => downloadmr(viewId, "mr.pdf")}
                      >
                        Download
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </Card>
          </Container>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ViewSmr
